export const environment = {
    baseURL: 'https://xylus.com/api/api',
    version: 'v1',
    imageUrl: 'https://xylus.com/api/',
    isServer: "true",
}
export default environment